import { render, staticRenderFns } from "./DealerContact.vue?vue&type=template&id=f3280184"
import script from "./DealerContact.vue?vue&type=script&lang=js"
export * from "./DealerContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports